var _style, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExperianSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 27 27",
    style: {
      enableBackground: "new 0 0 27 27"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#406EB3;}\n\t.st1{fill:#632678;}\n\t.st2{fill:#982881;}\n\t.st3{fill:#BA2F7D;}\n\t.st4{fill:#26478D;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.5,6.5h-3c-0.9,0-1.6-0.7-1.6-1.6v-3c0-0.9,0.7-1.6,1.6-1.6h3c0.9,0,1.6,0.7,1.6,1.6v3 C18.1,5.8,17.4,6.5,16.5,6.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.7,13.2H5.3c-1,0-1.8-0.8-1.8-1.8V8c0-1,0.8-1.8,1.8-1.8h3.4c1,0,1.8,0.8,1.8,1.8v3.4 C10.5,12.4,9.7,13.2,8.7,13.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M8.4,20.2H6.3c-0.6,0-1.1-0.5-1.1-1.1v-2.1c0-0.6,0.5-1.1,1.1-1.1h2.1c0.6,0,1.1,0.5,1.1,1.1v2.1 C9.5,19.7,9,20.2,8.4,20.2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M13.9,26.7h-2.4c-0.7,0-1.3-0.6-1.3-1.3V23c0-0.7,0.6-1.3,1.3-1.3h2.4c0.7,0,1.3,0.6,1.3,1.3v2.4 C15.2,26.2,14.6,26.7,13.9,26.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M22.8,7.7h-1.7c-0.5,0-0.9-0.4-0.9-0.9V5.1c0-0.5,0.4-0.9,0.9-0.9h1.7c0.5,0,0.9,0.4,0.9,0.9v1.7 C23.8,7.3,23.4,7.7,22.8,7.7z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M22.4,14.5c0-2.5-2.2-4.6-4.8-4.6c-2.7,0-4.9,2.2-4.9,4.8c0,2.7,2.2,4.9,4.9,4.9c1.3,0,2.5-0.5,3.4-1.4 c0.2-0.1,0.3-0.4,0.3-0.6c0-0.4-0.4-0.8-0.8-0.8c-0.2,0-0.5,0.1-0.6,0.3c-0.5,0.6-1.3,0.9-2.2,0.9c-1.6,0-2.9-1.1-3.2-2.6h7.3 c0,0,0,0,0,0h0h0c0,0,0.1,0,0.1,0C22.1,15.3,22.4,15,22.4,14.5z M17.5,11.6c1.5,0,2.7,0.9,3.1,2.3h-6.2C14.8,12.5,16,11.6,17.5,11.6 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperianSmall);
export default __webpack_public_path__ + "static/media/experian_small.4c153c16a61be1ad6a624b4a5e6c1073.svg";
export { ForwardRef as ReactComponent };